
export const Graph = ( { children, height, width, margin }) => (
  <svg  preserveAspectRatio="xMidYMid meet" viewBox={`0 0 ${width} ${height}`} className="svg-content">
    <g transform={`translate(${margin.left},${margin.top})`}>
      <line className="axis-line" 
        x2={width-margin.left-margin.right}
        y1={height-margin.top-margin.bottom}
        y2={height-margin.top-margin.bottom}
        style={{stroke: "c0c0bb", strokeWidth: 2}}
      />
      <line 
        className="axis-line" 
        y2={height-margin.top-margin.bottom}
        style={{stroke: "c0c0bb", strokeWidth: 2}}
      />
      {children}
    </g>
  </svg>
);
